import { useState } from "react";
import { Stack, Input, Button, Snackbar, Box } from "@mui/joy";
import { useCreateTagMutation } from "@/features/tags/api";
import { statusCodeToMessage } from "@/utils/errors";
import { EmojiPickerButton } from "@/components/EmojiPickerButton";
import AddIcon from "@mui/icons-material/Add";

const ERROR_OVERRIDES = { 409: "A tag with this name already exists." };

export function AddTagForm({ householdId }) {
  const [createTag, { isLoading }] = useCreateTagMutation();
  const [name, setName] = useState("");
  const [emoji, setEmoji] = useState("");
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    const trimmed = name.toLowerCase().trim();
    if (!trimmed) return;

    setError(null);
    try {
      await createTag({ householdId, data: { name: trimmed, emoji } }).unwrap();
      setName("");
      setEmoji("");
    } catch (err) {
      setError(statusCodeToMessage(err.status, ERROR_OVERRIDES));
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSubmit();
  };

  return (
    <>
      <Stack direction="row" gap={1} alignItems="center">
        <EmojiPickerButton emoji={emoji} onEmojiSelect={setEmoji} disabled={isLoading} size="md" />
        <Input
          placeholder="New tag name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={isLoading}
          sx={{ flex: 1 }}
        />
        <Button
          variant="solid"
          color="primary"
          onClick={handleSubmit}
          disabled={!name.trim()}
          loading={isLoading}
          startDecorator={<AddIcon />}
          sx={{ pr: { xs: 0.5, sm: 2 } }}
        >
          <Box sx={{ display: { xs: "none", sm: "inline" } }}>Add Tag</Box>
        </Button>
      </Stack>
      <Snackbar
        color="danger"
        variant="soft"
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={!!error}
        onClose={() => setError(null)}
      >
        {error}
      </Snackbar>
    </>
  );
}
